import script from "./ReviewInitiatedPriorAuthPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewInitiatedPriorAuthPage.vue?vue&type=script&setup=true&lang=js"

import "./ReviewInitiatedPriorAuthPage.vue?vue&type=style&index=0&id=8cd022b6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8cd022b6"]])

export default __exports__